export const STARTED = 'STARTED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const FAULT = 'FAULT';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';
export const INVALID = 'INVALID';
export const PENDING_APPROVAL = 'PENDING_APPROVAL';
export const APPROVED = 'APPROVED';
export const REJECTED = 'REJECTED';
export const QUEUED = 'QUEUED';

export const STOPPED = 'STOPPED';
export const RUNNING = 'RUNNING';
export const LAUNCHING = 'LAUNCHING';
export const DESTROYING = 'DESTROYING';
export const LAUNCH_FAILED = 'LAUNCH_FAILED';
export const DESTROY_FAILED = 'DESTROY_FAILED';
export const UNKNOWN = 'UNKNOWN';
export const SCALE_DOWN_FAILED = 'SCALE_DOWN_FAILED';
export const SCALE_UP_FAILED = 'SCALE_UP_FAILED';
export const SCALING_UP = 'SCALING_UP';
export const SCALING_DOWN = 'SCALING_DOWN';

export const HOTFIX = 'HOTFIX';
export const RELEASE = 'RELEASE';
export const LAUNCH = 'LAUNCH';
export const DESTROY = 'DESTROY';
export const CUSTOM = 'CUSTOM';
export const UNLOCK_STATE = 'UNLOCK_STATE';
export const PLAN = 'PLAN';
export const APPLY_PLAN = 'APPLY_PLAN';
export const HOTFIX_PLAN = 'HOTFIX_PLAN';
export const ROLLBACK_PLAN = 'ROLLBACK_PLAN';
export const APPLY_ROLLBACK_PLAN = 'APPLY_ROLLBACK_PLAN';
export const APPLY_HOTFIX_PLAN = 'APPLY_HOTFIX_PLAN';
export const SCALE_UP = 'SCALE_UP';
export const SCALE_DOWN = 'SCALE_DOWN';
export const MAINTENANCE = 'MAINTENANCE';
export const TERRAFORM_EXPORT = 'TERRAFORM_EXPORT';

export const STATUS_MAPPING = {
  [STARTED]: {
    statusText: 'STARTED',
    background: '#00C2BB',
  },
  [IN_PROGRESS]: {
    statusText: 'IN PROGRESS',
    background: '#007bff',
  },
  [FAULT]: {
    statusText: 'NO CHANGE',
    background: '#6c757d',
  },
  [SUCCEEDED]: {
    statusText: 'SUCCESS',
    background: '#28a745',
  },
  [FAILED]: {
    statusText: 'FAIL',
    background: '#dc3545',
    showImg: true,
  },
  [INVALID]: {
    statusText: 'INVALID',
    background: '#ffaa00',
    showImg: true,
  },
  [PENDING_APPROVAL]: {
    statusText: 'PENDING APPROVAL',
    background: '#EEF2F6',
  },
  [APPROVED]: {
    textColor: '#1EB75A',
    statusText: 'APPROVED',
    background: '#FFF',
    border: '1px solid',
  },
  [REJECTED]: {
    textColor: '#dc3545',
    statusText: 'REJECTED',
    background: '#FFF',
    border: '1px solid',
  },
  [QUEUED]: {
    statusText: 'QUEUED',
    background: '#ffaa00',
  },
};

export const deploymentValueNameMapping = {
  HOTFIX: 'SELECTIVE',
  RELEASE: 'FULL',
  LAUNCH: 'LAUNCH',
  DESTROY: 'DESTROY',
  SCALE_UP: 'SCALE UP',
  SCALE_DOWN: 'SCALE DOWN',
  CUSTOM: 'CUSTOM',
  UNLOCK_STATE: 'UNLOCK STATE',
  PLAN: 'FULL PLAN',
  APPLY_PLAN: 'APPLY FULL PLAN',
  HOTFIX_PLAN: 'SELECTIVE PLAN',
  APPLY_HOTFIX_PLAN: 'APPLY SELECTIVE PLAN',
  ROLLBACK_PLAN: 'ROLLBACK PLAN',
  APPLY_ROLLBACK_PLAN: 'APPLY ROLLBACK PLAN',
  MAINTENANCE: 'MAINTENANCE',
  TERRAFORM_EXPORT: 'TERRAFORM EXPORT',
};

export const releaseTypesDropdown = [
  { value: HOTFIX, title: deploymentValueNameMapping[HOTFIX] },
  { value: RELEASE, title: deploymentValueNameMapping[RELEASE] },
  { value: LAUNCH, title: deploymentValueNameMapping[LAUNCH] },
  { value: DESTROY, title: deploymentValueNameMapping[DESTROY] },
  { value: SCALE_UP, title: deploymentValueNameMapping[SCALE_UP] },
  {
    value: SCALE_DOWN,
    title: deploymentValueNameMapping[SCALE_DOWN],
  },
  { value: CUSTOM, title: deploymentValueNameMapping[CUSTOM] },
  {
    value: UNLOCK_STATE,
    title: deploymentValueNameMapping[UNLOCK_STATE],
  },
  { value: PLAN, title: deploymentValueNameMapping[PLAN] },
  {
    value: APPLY_PLAN,
    title: deploymentValueNameMapping[APPLY_PLAN],
  },
  {
    value: HOTFIX_PLAN,
    title: deploymentValueNameMapping[HOTFIX_PLAN],
  },
  {
    value: APPLY_HOTFIX_PLAN,
    title: deploymentValueNameMapping[APPLY_HOTFIX_PLAN],
  },
  {
    value: ROLLBACK_PLAN,
    title: deploymentValueNameMapping[ROLLBACK_PLAN],
  },
  {
    value: APPLY_ROLLBACK_PLAN,
    title: deploymentValueNameMapping[APPLY_ROLLBACK_PLAN],
  },
  {
    value: MAINTENANCE,
    title: deploymentValueNameMapping[MAINTENANCE],
  },
  {
    value: TERRAFORM_EXPORT,
    title: deploymentValueNameMapping[TERRAFORM_EXPORT],
  },
];

export const SUPPORTED_QUEUED_RELEASE_TYPES = [
  HOTFIX,
  RELEASE,
  CUSTOM,
  PLAN,
  HOTFIX_PLAN,
];
